import React, { Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { withI18n } from "react-i18next";
import { client } from "../../shared/apiClient";
import { IVideoDirectionInfo } from "../../interfaces/IVideoDirections";
// @ts-ignore
import { CWBVideoPlayer, CWBLoadingCrest } from "cwb-react";
import imageSrc from "../../images/icon-cwb-logo-grey.svg";
import logoImageSrc from "../../images/icon-cwb-logo-full.svg";
import { IMedia } from "../../interfaces/IMedia";

import "cwb-react/dist/cwb-react.css";
import "video.js/dist/video-js.css";

const queryString = require("qs");

interface IState {
  vdInfo?: IVideoDirectionInfo;
  media: IMedia;
  isLoading?: boolean;
  isVDAvailable: boolean;
  iframed: boolean;
}

interface IProps extends DispatchProps {
  t: any;
  match: any;
}

class ActorVideoDirection extends React.Component<IProps, IState> {
  public state: IState = {
    vdInfo: {} as IVideoDirectionInfo,
    media: {} as IMedia,
    isLoading: true,
    isVDAvailable: false,
    iframed: false,
  };

  notInFrameOrUndetectable(): boolean {
    try {
      return window.location === window.parent.location;
    } catch (ex) {
      return true;
    }
  }

  async componentWillMount() {
    try {
      const authToken = localStorage.getItem("CWBAPI_TOKEN");
      const qsArgs = decodeURI(window.location.search).split("?")[1];
      const result = queryString.parse(qsArgs);
      let vdResp;

      let token =
        this.props.match && this.props.match.params
          ? this.props.match.token
          : "";
      if (!token) {
        token = result.token;
      }

      if (token) {
        vdResp = await client.api.videoDirection.getTokenVideoDirection(token);
      } else if (authToken) {
        vdResp = await client.api.videoDirection.getClientVideoDirection(
          result.roleId || result.roleid,
          result.sch || result.scheduleId || result.scheduleid
        );
      } else {
        vdResp = null;
      }

      if (vdResp && vdResp.data) {
        const vdInfo: IVideoDirectionInfo = vdResp.data;
        await this.setState({ vdInfo });
        let qs = "";
        if (vdInfo.roleId) qs += `roleId=${vdInfo.roleId}`;
        if (vdInfo.scheduleId)
          qs += `${vdInfo.roleId ? "&" : ""}sch=${vdInfo.scheduleId}`;
        if (vdInfo.auditionScheduleId)
          qs += `${vdInfo.roleId || vdInfo.scheduleId ? "&" : ""}saud=${
            vdInfo.auditionScheduleId || result.saud
          }`;
        let mediaRespData = await client.api.pm.getActorMedia(
          vdInfo.videoId,
          qs
        );
        if (mediaRespData) {
          await this.setState({
            isVDAvailable:
              mediaRespData.sources && mediaRespData.sources.length > 0,
            media: mediaRespData,
            isLoading: false,
            iframed: !this.notInFrameOrUndetectable(),
          });
        } else {
          this.setState({
            isVDAvailable: false,
            isLoading: false,
            iframed: !this.notInFrameOrUndetectable(),
          });
        }
      } else {
        // @ts-ignore
        window.location = `${
          client.api.paths.redirect403
        }?actorVideoDirection&${
          decodeURI(window.location.search).split("?")[1]
        }`;
      }
    } catch (e) {
      // @ts-ignore
      window.location = `${client.api.paths.redirect500}?actorVideoDirection&${
        decodeURI(window.location.search).split("?")[1]
      }`;
      return;
    }
  }

  componentDidMount() {
    const { t, setDocumentTitle } = this.props;
    setDocumentTitle(t("VCR Video Directions"));
  }

  componentWillUnmount() {
    this.props.setDocumentTitle("");
  }

  render() {
    const { t } = this.props;
    const { vdInfo, media, isLoading } = this.state;

    if (isLoading) return <CWBLoadingCrest customLogoSrc={imageSrc} />;
    return (
      <Fragment>
        {!this.state.iframed && (
          <HeaderWrapper>
            <HeaderBox>
              <img alt="Casting Workbook" src={logoImageSrc} />
            </HeaderBox>
          </HeaderWrapper>
        )}
        <Wrapper>
          {this.state.isVDAvailable ? (
            <Title>
              {t(
                `Video Directions for ${vdInfo.roleName} ${vdInfo.projectName}`
              )}
            </Title>
          ) : (
            <Title>
              {t(
                `No Video Directions for ${vdInfo.roleName} ${vdInfo.projectName}`
              )}
            </Title>
          )}
          {this.state.isVDAvailable && media && (
            <StyledVideoPlayer
              key={media.mediaId}
              autoplay={true}
              src={media.sources[0].url}
            />
          )}
        </Wrapper>
      </Fragment>
    );
  }
}

const HeaderWrapper = styled.div`
  background: ${(p) => p.theme.white};
  box-shadow: inset 0 -1px 0 0 #e7e7f0;
  border-bottom: 1px solid #edf1f4;
`;

const HeaderBox = styled.div`
  height: 95px;
  max-width: 1040px;
  display: flex;
  justify-content: start;
  margin: 0 auto;
`;

const Wrapper = styled.div`
  width: 800px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 24px auto;
  
  .cwb-video-player {  
      height: 450px;
      width: 100%;
      .video-js {
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-color: #000;
      }

      .video-js .vjs-tech{
        position: relative !important;
      }

      .play-controls-wrapper {
        display: flex;
      }
  
      .top-control-bar {
        bottom: 32px;
      }

      .vjs-progress-control{
        min-width: 100%;
      }

      .vjs-play-progress {
        background: #00AAFF;
        border-radius: 6.5px;
      }

      .vjs-progress-holder {
        background-color: #E0E4E9;
        height: 4px;
        border-radius: 6.5px;
      }

      .vjs-load-progress div {
        background-color: #E0E4E9;
        border-radius: 6.5px;
      }

      .vjs-big-play-button {
        display: none;
      }

      .vjs-volume-level {
        background:white;
        height: 2px;
        border-radius: 100px;

        &:before {
          font-size: 10px;
          width: 10px;
          color: white;
          border-radius: 16px;
          box-shadow: 0 1px 1px 0 rgba(35, 53, 57, 0.07), 0 0 1px 1px rgba(35, 53, 57, 0.11), 0 3px 2px 0 rgba(35, 53, 57, 0.1), 0 4px 9px 4px rgba(35, 53, 57, 0.08);
          background: white;
          top: -3px;
          right: -5px;
        }
      }


      .video-js .vjs-volume-control.vjs-volume-horizontal {
        width: 80px;
      }

      .vjs-volume-bar {
        background-color: #E0E4E9;
        border-radius: 100px;
        height: 2px;
        width: 100%;
        margin: 8px 4px;
      }

      .video-js .vjs-time-control {
        display: block;
        line-height: 16px;
        height: 16px;
      }

      .video-js .vjs-current-time {
        display: block;
        padding: 0px;
        margin-left: 20px;

        span {
          color: white;
          font-size: 10px;
        }
      }

      .video-js .vjs-duration {
        display: block;
        padding: 0px;

        span {
          color: white;
          font-size: 10px;
        }
      }

      .vjs-time-divider {
        padding: 0px;
        margin: 0px;
        min-width: 10px;

        span {
          color: white;
          font-size: 14px;
        }
      }

      .vjs-play-progress:before {
        display: none;
      }

      .vjs-play-control .vjs-icon-placeholder:before,
      .vjs-button > .vjs-icon-placeholder:before{
        font-size: 16px;
        line-height: 16px;
        height: 16px;
      }

      .previous-track-btn.icon-cwb-previous-track-white,
      .next-track-btn.icon-cwb-next-track-white{
        line-height: 16px;
        height: 16px;
      }

      .vjs-fullscreen-control {
           right: -4px;
          .vjs-icon-placeholder:before {
            font-size: 20px;
            line-height: 16px;
            height: 16px;
          }
      }

      .previous-track-btn {
        margin-left: 10px;
        cursor: pointer;

        &.disabled-control {
          cursor: unset;
          opacity: 0.5;
        }
      }

      .control-spacer {
        flex-grow: 1;
      }

      .next-track-btn {
        cursor: pointer;

        &.disabled-control {
          cursor: unset;
          opacity: 0.5;
        }
      }
      
      .video-js .vjs-control{
        outline: 0;
      }

      .vjs-control-bar {
        display: block;
        height: 24px;
        background: transparent;
      }

      .vjs-play-control span {
        color: white;
      }

      .vjs-mute-control {
        margin-left: 15px;
        width: 20px;

        span {
          color: white;
        }
      }

      .vjs-fullscreen-control span {
        color: white;
      }

      .bottom-control-bar {
        display: flex;
      }
    }
  }
  
  @media (max-width: 576px) {
    width: 90%;
    .cwb-video-player { 
      width: 100%;
      height: 212px;
    }
  }
`;

const Title = styled.div`
  font-size: 24px;
  line-height: 32px;
  color: ${(p) => p.theme.black};
`;

const StyledVideoPlayer = styled(CWBVideoPlayer)`
  margin-top: 24px;
`;

interface DispatchProps {
  setDocumentTitle: (documentTitle: string) => any;
}

const mapDispatchToProps = (dispatch: any) => ({
  setDocumentTitle: dispatch.app.setDocumentTitle
});

export default withI18n()(connect(
  null,
  mapDispatchToProps
)(ActorVideoDirection));
